import React from "react";

export default function Base({}) {
	return <>
		<path d="M100 72.7778V27.2222C100 12.2222 87.5556 0 72.3333 0H27.6667C12.4444 0 0 12.2222 0 27.2222V100H72.3333C87.5556 100 100 87.7778 100 72.7778Z"/>
	</>
}